import React from 'react';
import styled from 'styled-components';

// Styled component for the footer
const FooterContainer = styled.footer`
  background-color: transparent;
  color: #aaa;
  padding: 20px;
  text-align: center;
  pointer-events: none;
  user-select: none;
  /* position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
  z-index: 1; */
`;

// Component definition
const Footer = () => {
  return (
    <FooterContainer>
      © 2024 Sachin. All rights reserved.
    </FooterContainer>
  );
};

export default Footer;
